<template>
  <label class="form-label" for="company-name">{{
    $t('subscribeToEventUpdatesModal.firstStep.form.companyName.label')
  }}</label>
  <div class="position-relative">
    <input
      id="company-name"
      v-model="form.companyName"
      autocomplete="company name"
      class="w-full border border-gray-200 rounded-lg p-2 bg-white mt-1"
      name="company-name"
      @input="emit('clearErrors', 'companyName')"
    />
    <span
      v-if="invalidKeys.includes('companyName')"
      data-test-id="date-request-form-invalid"
      class="text-red text-sm block"
    >
      {{ errors.companyName }}
    </span>

    <span class="block mb-2 text-xs text-gray-400">
      {{
        $t('subscribeToEventUpdatesModal.firstStep.form.companyName.helperText')
      }}
    </span>
  </div>
  <label class="form-label" for="city">{{
    $t('subscribeToEventUpdatesModal.firstStep.form.city.label')
  }}</label>
  <div class="position-relative">
    <input
      id="city"
      v-model="form.city"
      autocomplete="city"
      class="w-full border border-gray-200 rounded-lg p-2 bg-white mt-1"
      name="city"
      @input="emit('clearErrors', 'city')"
    />
    <span
      v-if="invalidKeys.includes('city')"
      data-test-id="date-request-form-invalid"
      class="text-red text-sm block"
    >
      {{ errors.city }}
    </span>
    <span class="block mb-2 text-xs text-gray-400">
      {{ $t('subscribeToEventUpdatesModal.firstStep.form.city.helperText') }}
    </span>
  </div>

  <div class="mt-4">
    <label class="form-label" for="additional-info">
      {{
        $t('subscribeToEventUpdatesModal.firstStep.form.additionalInfo.label')
      }}
    </label>
    <textarea
      id="additional-info"
      v-model="form.additionalInfo"
      :placeholder="
        $t(
          'subscribeToEventUpdatesModal.firstStep.form.additionalInfo.placeholder'
        )
      "
      class="w-full border border-gray-200 rounded-lg p-2 bg-white mt-1 h-16 resize-none"
      name="additional-info"
      @input="emit('clearErrors', 'additionalInfo')"
    />
    <span
      v-if="invalidKeys.includes('additionalInfo')"
      data-test-id="date-request-form-invalid"
      class="text-red text-sm"
    >
      {{ errors.additionalInfo }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type {
  DateRequestErrors,
  DateRequestInvalidKeys,
} from './dateRequestTypes'

interface Props {
  errors?: DateRequestErrors
  invalidKeys?: DateRequestInvalidKeys
}
const { errors = {}, invalidKeys = [] } = defineProps<Props>()

const emit = defineEmits<{
  (e: 'clearErrors', field: string): void
}>()

const form = defineModel<any>({ required: true })
</script>
<style lang="postcss" scoped>
.required:after {
  content: '*';
  position: relative;
  font-size: inherit;
  @apply text-red;
  padding-left: 0.25rem;
  font-weight: 700;
}
</style>
